// The forecast server's proxied utility routes (C-33: network I/O lives in `services/` or
// `lib/apiClient`). Each function is the `fetch` its call site made, moved here unchanged and
// returning the `Response` untouched, so the caller keeps its own status handling.

const JSON_HEADERS = { "Content-Type": "application/json" };

/**
 * `POST /api/forecast/llm`: one model call. `headers` are the caller's extra headers (a chat
 * turn's), `signal` its abort signal.
 */
export function postLlm(
  body: Record<string, unknown>,
  { headers = {}, signal }: { headers?: Record<string, string>; signal?: AbortSignal } = {},
): Promise<Response> {
  return fetch("/api/forecast/llm", {
    method: "POST",
    headers: { ...JSON_HEADERS, ...headers },
    body: JSON.stringify(body),
    signal,
  });
}

/**
 * `GET` a health route: `/api/forecast/health` (the forecasters and orchestrators) by default,
 * or the engine-selection probe URL the caller retries.
 */
export function fetchHealth(url = "/api/forecast/health"): Promise<Response> {
  return fetch(url);
}
